export default message => {
  if (typeof process !== 'undefined' && process && process.env && process.env.NODE_ENV !== 'production') {
    typeof console !== 'undefined' && console && console.warn && console.warn(message);
  }
};
